<template>
  <section v-if="shouldRender" id="testimonials" class="relative overflow-hidden bg-white section-padding">
    <div class="absolute inset-x-0 top-0 -z-10 h-72 bg-gradient-to-b from-hilab/10 via-white to-white blur-[160px]"></div>
    <div class="container-full-width">
      <div class="mx-auto max-w-3xl text-center">
        <span v-if="badge" class="badge">{{ badge }}</span>
        <h2 v-if="title" class="section-title mt-6">{{ title }}</h2>
        <p v-if="description" class="section-subtitle mx-auto">
          {{ description }}
        </p>
      </div>
      <div v-if="testimonialList.length" class="testimonials-grid grid-autofit">
        <article
          v-for="testimonial in testimonialList"
          :key="testimonial.author || testimonial.quote"
          class="testimonial-card flex h-full flex-col justify-between rounded-3xl border border-slate-100 bg-white/80 p-6 shadow-lg scroll-fade-in"
        >
          <div>
            <div v-if="testimonial.sector" class="flex items-center gap-2 text-sm font-semibold text-hilab">
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.75 5.25c0-1.518 1.232-2.75 2.75-2.75s2.75 1.232 2.75 2.75a2.75 2.75 0 0 1-2.75 2.75 2.75 2.75 0 0 0-2.75 2.75v.5A3.75 3.75 0 0 1 6 15h-.5A2.5 2.5 0 0 1 3 12.5v-.75A6.75 6.75 0 0 1 9.75 5.25Z" />
                <path d="M18.75 5.25c0-1.518 1.232-2.75 2.75-2.75S24.25 3.732 24.25 5.25a2.75 2.75 0 0 1-2.75 2.75 2.75 2.75 0 0 0-2.75 2.75v.5A3.75 3.75 0 0 1 15 15h-.5A2.5 2.5 0 0 1 12 12.5v-.75a6.75 6.75 0 0 1 6.75-6.5Z" transform="translate(-3 -2)" />
              </svg>
              {{ testimonial.sector }}
            </div>
            <p v-if="testimonial.quote" class="mt-4 text-lg font-semibold text-slate-900">“{{ testimonial.quote }}”</p>
          </div>
          <div class="mt-6 flex items-center justify-between">
            <div>
              <p v-if="testimonial.author" class="text-sm font-semibold text-slate-900">{{ testimonial.author }}</p>
              <p v-if="testimonial.role" class="text-xs text-slate-400">{{ testimonial.role }}</p>
            </div>
            <div v-if="testimonial.avatars && testimonial.avatars.length" class="flex -space-x-3">
              <img
                v-for="avatar in testimonial.avatars"
                :key="avatar"
                :src="avatar"
                alt=""
                class="h-9 w-9 rounded-full border-2 border-white object-cover"
              />
            </div>
          </div>
        </article>
      </div>
      <div v-if="industries.length" class="mt-12 flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400">
        <span class="uppercase tracking-[0.3em]">Được tin dùng bởi</span>
        <div class="flex flex-wrap items-center gap-3 text-slate-400">
          <span v-for="brand in industries" :key="brand" class="rounded-full border border-slate-100 px-4 py-2">
            {{ brand }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
});

const toArray = value => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') return Object.values(value);
  return [];
};

const sectionContent = computed(() => props.content || {});
const badge = computed(() => sectionContent.value.badge || '');
const title = computed(() => sectionContent.value.title || '');
const description = computed(() => sectionContent.value.description || '');
const testimonialList = computed(() =>
  toArray(sectionContent.value.items).filter(item => item?.quote)
);
const industries = computed(() => {
  const industryData = sectionContent.value.industries;
  if (Array.isArray(industryData)) {
    return industryData.filter(Boolean);
  }
  if (industryData && typeof industryData === 'object') {
    return Object.values(industryData).filter(Boolean);
  }
  return [];
});
const shouldRender = computed(() => title.value || description.value || testimonialList.value.length);
</script>
